import { F0Box, F0Card, F0Text, useAiChat } from '@factorialco/f0-react'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'

import { File as FileIcon } from '@factorialco/f0-react/icons/app'
import i18n from 'modules/core/lib/i18n'

export const OneFooter = ({ onClickStartFromScratch }: { onClickStartFromScratch: () => void }) => {
  const { visualizationMode, setOpen, setVisualizationMode } = useAiChat()
  const isFullscreen = visualizationMode === 'fullscreen'

  const handleClick = useUnsafeCallback(() => {
    setVisualizationMode('sidepanel')
    setOpen(false)
    onClickStartFromScratch()
  }, [onClickStartFromScratch, setVisualizationMode, setOpen])

  if (!isFullscreen) {
    return null
  }

  return (
    <F0Box display="flex" gap="lg" flexDirection="column" width="full">
      <F0Text variant="label" content={i18n.t('planning.one_footer.or_start_with')} />
      <F0Box display="grid" columns="2" gap="xl" width="full">
        <F0Card
          title={i18n.t('planning.one_footer.empty_period')}
          description={i18n.t('planning.one_footer.empty_period_description')}
          avatar={{
            icon: FileIcon,
            type: 'icon',
          }}
          onClick={handleClick}
        />
      </F0Box>
    </F0Box>
  )
}
